export * from './src/bookings-v2-attendance-attendance.schemas.js';
